import axios from "axios";
export default {
	methods: {
		loadData() {
			let me = this;
			let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
			axios.get(link + me.id)
				.then((response) => {
					me.jsonData = response.data.data;
					let tmpDashboard = JSON.parse(response.data.data.dashboard);
					me.dashboard.headerElements = tmpDashboard.headerElements.sort((a, b) => a.position - b.position);
					me.dashboard.bodyElements = tmpDashboard.bodyElements.sort((a, b) => a.position - b.position);
					this.$emit("updateDashBoard", response.data.data);
				})
				.catch((e) => {
					console.log(e);
				});
		},
	},
};
